<template>
<v-app>
    <v-main>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">نمونه جدول</h3>
        </div>
      </div>
      <div class="card-body">
        <!--begin::Example-->
        <div class="example mb-10">

            <v-container fluid>
                <v-card :loading="loading" elevation="2" outlined>
                    <v-card-title v-if="$can('role_create')">
                        مدیریت دسته بندی ها
                        <v-spacer/>
                        <input type="file" id="excel-upload" @change="picked" style="display: none">
                        <v-btn to="/categories/create" rounded color="#308BB0">
                            <v-icon>mdi-plus</v-icon>
                            افزودن دسته بندی
                        </v-btn>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                    </v-card-text>
                    <v-divider/>

                    <datatable
                        :columns="columns"
                        :data="data"
                        :total="total"
                        :query="query"
                        :xprops="xprops"
                        :HeaderSettings="false"
                        :pageSizeOptions="[10, 25, 50, 100]"
                    >
                    </datatable>




<!--                    <v-simple-table>-->
<!--                        <thead>-->
<!--                        <tr>-->
<!--                            <th v-text="`#`" class="order" id="category_id"/>-->
<!--                            <th v-text="`تصویر`"/>-->
<!--                            <th v-text="`نام`" class="order" id="name"/>-->
<!--                            <th v-text="`وضعیت`"/>-->
<!--                            <th v-text="`تعداد کالا`" class="order" id="products_count"/>-->
<!--                            <th v-text="`شماره ترتیب`" class="order" id="sort_order"/>-->
<!--                            <th v-text="`زیر دسته`"/>-->
<!--                            <th v-text="`ایجاد`" class="order" id="date_added"/>-->
<!--                            <th v-text="`ویرایش`" class="order" id="date_modified"/>-->
<!--                            <th v-text="`عمل`"/>-->
<!--                        </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->
<!--                        <tr v-for="(x, i) in categories.data" :key="i">-->
<!--                            <td v-text="x.id"/>-->
<!--                            <td class="py-2">-->
<!--                                <v-avatar width="50" height="50">-->
<!--                                    <v-img :src="x.image || 'media/avatar.png'"/>-->
<!--                                </v-avatar>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                {{ x.name }}-->
<!--                                <v-icon v-if="x.special">mdi-star</v-icon>-->
<!--                            </td>-->
<!--                            <td v-text="x.status"/>-->
<!--                            <td>-->
<!--                                <v-chip v-text="sad"/>-->
<!--                            </td>-->
<!--                            <td v-text="x.sort_order"/>-->
<!--                            <td>-->
<!--                                <v-chip v-if="x.parent != null && x.parent.name != null">-->
<!--                                    {{ x.parent.name }}-->
<!--                                </v-chip>-->
<!--                            </td>-->
<!--                            <td v-text="x.date_added"/>-->
<!--                            <td v-text="x.date_modified"/>-->
<!--                            <td>-->
<!--                                <v-btn icon >-->
<!--                                    <v-icon>mdi-pencil</v-icon>-->
<!--                                </v-btn>-->

<!--                                <v-btn >-->
<!--                                    <v-icon>mdi-delete</v-icon>-->
<!--                                </v-btn>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                    </v-simple-table>-->
<!--                    <v-divider/>-->
<!--                    <v-card-actions>-->
<!--                        <route-pagination :visible="2" :data="categories.data" v-on:page="changePage"/>-->
<!--                    </v-card-actions>-->
                </v-card>

            </v-container>

        </div>
        <!--end::Example-->
      </div>
    </div>
    </v-main>
</v-app>
</template>

<script>
import { mapGetters,mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RoutePagination from "../../content/route-pagination";
import CategoryPicker from "../../content/pickers/categoryPicker";
import DatatableActions from "../../content/Datatables/DatatableActions";

export default {
  name: "table-sample",
  components: {CategoryPicker, RoutePagination},
  data() {
    return {
        columns: [
            {
                title: 'شناسه',
                field: 'id',
                sortable: true,
                colStyle: 'width: 100px;'
            },
            {
                title: 'نام',
                field: 'name',
                sortable: true
            },
            {
                title: 'توضیحات',
                field: 'description',
                sortable: true
            },
            {
                title: 'کارها',
                tdComp: DatatableActions,
                visible: true,
                thClass: 'text-right',
                tdClass: 'text-right td-actions',
                colStyle: 'width: 150px;'
            }
        ],
        query: {sort: 'id', order: 'desc', limit: 100, s: ''},
        xprops: {
            module: 'CategoriesIndex',
            route: 'categories',
            permission_prefix: 'permission_'
        },
        excel: {
            file: null,
            loading: false,
            percent: 0,
            errors: {}
        },
        // loading: false,
        categories: {
            data: []
        },
        queries: {
            search: '',
            parent_id: null,
            sort: "",
            order: "desc",
        },
        deleteCategory: {
            dialog: false,
            loading: false,
            confirm: false,
            categoryId: 0
        },
        page: 1,
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
      ...mapGetters('PermissionsIndex', ['data', 'total', 'loading']),

    config() {
      return this.layoutConfig();
    }
  },

    created() {
        // if (this.$store.state.localStorage.admin_categories != null) {
        //     this.queries = this.$store.state.localStorage.admin_categories;
        // }
        // this.$vuetify.rtl = true;
        // this.fetch(this.$route.query.page || 1);
    },
    watch:{
        query: {
            handler(query) {
                this.setQuery(query)
                this.fetchIndexData()
            },
            deep: true
        }
        // queries: {
        //     handler: function (value) {
        //         if (value.sort !== this.old_sort || value.order !== this.old_order) {
        //             let children = document.getElementById(this.old_sort);
        //             if (children !== null && children !== undefined) {
        //
        //                 for (let i = 0; i < children.childNodes.length; i++) {
        //                     children.childNodes[i].remove();
        //                 }
        //             }
        //             let element = document.getElementById(value.sort);
        //             if (element !== null && element !== undefined) {
        //                 this.fetch()
        //                 element.innerHTML = `<i aria-hidden="true" style="color:#ec407a" class="v-icon notranslate mdi
        //                             ${value.order === 'desc' ? 'mdi-chevron-down' : 'mdi-chevron-up'}
        //                              theme--light"></i> ${element.innerText}`;
        //             }
        //             this.old_sort = value.sort;
        //             this.old_order = value.order;
        //         }
        //     },
        //     deep: true
        // }
    },
  mounted() {
      let me = this.queries;
      let orders = document.getElementsByClassName("order");
      for (let i = 0; i < orders.length; i++) {
          orders[i].addEventListener('click', function (e) {

              if (me.sort === e.target.id) {
                  me.order = me.order === 'desc' ? 'asc' : 'desc';
              }
              if (e.target.id !== null && e.target.id.length > 0) {
                  me.sort = e.target.id;
              }
          }, false);
      }
  },
  destroyed() {
  },
    methods: {
        destroy() {
            if (!this.deleteCategory.confirm) return
            this.deleteCategory.loading = true;
            this.requestApiDelete().delete(`categories/${this.deleteCategory.categoryId}`)
                .then(({data}) => {
                    this.$root.$emit('successToast', 'موفق');
                    this.fetch();
                })
                .catch(({response}) => {
                    if (response.data != null) {
                        this.$root.$emit('errorToast', response.message);
                    } else {
                        this.$root.$emit('errorToast', response.message);
                    }
                })
                .finally(() => {
                    this.deleteCategory = {
                        dialog: false,
                        loading: false,
                        confirm: false,
                        categoryId: 0
                    };
                });
        },
        destroyDialog(id) {
            this.deleteCategory.categoryId = id;
            this.deleteCategory.dialog = true;
        },
        pick() {
            document.getElementById("excel-upload").click();
        },
        picked(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            if (files.length >= 1) {

                this.excel.file = files[0];
                this.excel.errors = {};
                this.excel.loading = true;

                let config = {
                    headers: {'Content-Type': 'multipart/form-data'},
                    onUploadProgress: function (progressEvent) {
                        this.excel.percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        this.$forceUpdate();
                    }.bind(this)
                };

                let formData = new FormData();

                formData.append("excel", this.excel.file);

                this.$api.post('categories/import', formData, config)
                    .then(({data}) => this.$root.$emit('successToast', 'موفق'))
                    .catch(({response}) => {
                        if (response.data != null) {
                            this.excel.errors = response.data;
                            this.$root.$emit('errorToast', response.excel.message);
                        } else {
                            this.$root.$emit('errorToast', response.message);
                        }
                    })
                    .finally(() => this.excel.loading = false);
            }
        },
        changePage(page = 1) {
            this.$router.replace({path: `/categories?page=${page}`});
            this.fetch(page);
        },
        fetch(page = 1) {
            // this.$store.commit('localStorage/updateAdminOrders', {
            //     search: this.queries.search,
            //     order_by: this.queries.order_by,
            //     order_direction: this.queries.order_direction,
            //     parent_id: this.queries.parent_id,
            // });

            // this.loading = true;
            this.requestApiGet('categories', {
                params: {
                    page: page,
                    search: this.queries.search,
                    parent_id: this.queries.parent_id,
                    order_by: this.queries.sort,
                    order_direction: this.queries.order,
                }
            }).then(({data}) => {this.categories = data
            console.log(data)
            })
                .catch(({response}) => this.$root.$emit('errorToast', response.message))
                // .finally(() => this.loading = false);
        },
        ...mapActions('PermissionsIndex', [
            'fetchIndexData',
            'setQuery',
            'resetState'
        ])
    }
};
</script>
<style scoped>
th, td {
    text-align: center !important;
}
</style>

